import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

export interface IArticleContent {
  Type: string;
  Content: string;
  Image: {
    src: string;
  };
}

interface IArticle {
  Title: string;
  Content: IArticleContent[] | null;
}

interface IArticleDataResult {
  fetch: {
    Common: {
      Articles: {
        Background: string | null;
      } | null;
    };
    Country: {
      HomePage: {
        NewsSection: {
          Article: IArticle | null;
        } | null;
      };
    };
  };
}

interface IVariables {
  country: string;
  article: string;
}

interface IRequiredProps {
  country: string;
  articleId: string;
}

export type WithArticleQueryProps = QueryResult<IArticleDataResult>;

class ArticleQuery extends Query<IArticleDataResult, IVariables> {}

const withArticleQuery = <P extends WithArticleQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithArticleQueryProps> & IRequiredProps> => props => {
  const { country, articleId } = props;
  return (
    <ArticleQuery
      query={queries.GET_ARTICLE_DATA}
      variables={{
        article: articleId,
        country
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </ArticleQuery>
  );
};

export default withArticleQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withArticleData.tsx